import { render, staticRenderFns } from "./VaItemSection.vue?vue&type=template&id=67d7512c&"
import script from "./VaItemSection.vue?vue&type=script&lang=js&"
export * from "./VaItemSection.vue?vue&type=script&lang=js&"
import style0 from "./VaItemSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports